
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ReactApexChart from "react-apexcharts";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

const Assessment = () => {

    const [searchInput, setSearchInput] = useState('');
    const [instituteId, setInstituteId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [scheduleId, setScheduleId] = useState('');
    const [asmntInstituteId, setAsmntInstituteId] = useState('');
    const [asmntBatchId, setAsmntBatchId] = useState('');
    const [asmntTypeId, setAsmntTypeId] = useState('');
    const [asmntStudId, setAsmntStudId] = useState('');
    const [assessmentDate, setAssessmentDate] = useState('');
    const [assessmentScdlDate, setAssessmentScdlDate] = useState('')
    const [comment, setComment] = useState('');
    const [grade, setGrade] = useState('');
    const [studentName, setStudentName] = useState('');
    const [institutionList, setInstitutionList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [assessmentTypeList, setAssessmentTypeList] = useState([]);
    const [assessmentDateList, setAssessmentDateList] = useState([]);
    const [assessmentSkillList, setAssessmentSkillList] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [asmntStudList, setasmntStudList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [studentAssessmntList, setStudentAssessmntList] = useState([]);
    const [studentAssessmntListEdit, setStudentAssessmntListEdit] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showStudentListModal, setShowStudentListModal] = useState(false);
    const [showSkillTable, setShowSkillTable] = useState(false);
    const [showChartModal, setShowChartModal] = useState(false);
    const [showChartEditModal, setShowChartEditModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showAddAssessmentModal, setShowAddAssessmentModal] = useState(false);
    const [bchPlaceHolder, setBchPlaceHolder] = useState('Please Wait...');
    const [asmntDatePlaceHolder, setAsmntDatePlaceHolder] = useState('Please Wait...');
    const [studPlaceHolder, setStudPlaceHolder] = useState('Please Wait...');

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        getInstitutionList();
        getassessmentTypeList();
    }, [])

    function getInstitutionList() {
        const instList = api.InstDd + '/' + roleId; //"?userId=" + userid + "&roleId=" + roleid;
        fetch(instList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == false) {
                    setInstitutionList(insResult.data)
                }
                else {
                    Swal.fire(insResult.message)
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error);
            })
    }

    function getassessmentTypeList() {
        const asmntTyp = api.AssessmentTypeList;
        fetch(asmntTyp, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == false) {
                    setAssessmentTypeList(typResult.data)
                }
                else {
                    Swal.fire(typResult.message)
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the assessment type list", error);
            })
    }

    function listBatch(instId: string | null) {
        const batch = api.AssessmentBatch + '/' + instId;
        //  "?insId=" + instId + "&userId=" + userid + "&roleId=" + roleid;
        fetch(batch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == false) {
                    setBchPlaceHolder("Select a Batch");
                    setBatchList(btchResult.data)
                }
                else {
                    Swal.fire(btchResult.message)
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error);
            })
    }

    function asesmentList(btchId: string | null) {
        const getList = api.AssessmentTypeList + '/' + btchId + '/' + instituteId;
        //  "?insId=" + instituteId + "&userId=" + userid + "&roleId=" + roleid + "&programId=" + btchId;
        fetch(getList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == false) {
                    setShowTable(true)
                    setAssessmentList(lstResult.data)
                }
                else {
                    Swal.fire(lstResult.message)
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch assessment list.", error);
            })
    }

    function asesmentDateList(btchId) {
        const dateLst = api.AssessmentDateList + '/' + btchId + '/' + asmntInstituteId;//"?batchId=" + btchId + "&insId=" + asmntInstituteId;
        fetch(dateLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((dateResponse) => dateResponse.json())
            .then((dateResult) => {
                if (dateResult.error == false) {
                    setAssessmentDateList(dateResult.data);
                    setAsmntDatePlaceHolder("Select Date");
                }
                else {
                    Swal.fire(dateResult.message)
                    if (dateResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch date list", error)
            })
    }

    function initialValues() {
        setShowAddAssessmentModal(true)
        setAsmntInstituteId("")
        setAsmntBatchId("")
        setAsmntTypeId("")
        setAssessmentScdlDate("")
        setAsmntStudId("")
        setShowSkillTable(false)
    }

    function getStudents(scdlDate) {
        const studsList = api.AssessmentStudents + '/' + asmntBatchId + '/' + scdlDate + '/' + asmntTypeId + '/' + asmntInstituteId;
        //  "?insId=" + asmntInstituteId + "&batchId=" + asmntBatchId + "&date=" + scdlDate + "&typeId=" + asmntTypeId;
        fetch(studsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((stuResponse) => stuResponse.json())
            .then((stuResult) => {
                if (stuResult.error == false) {
                    setasmntStudList(stuResult.data)
                    setStudPlaceHolder("Select Student")
                }
                else {
                    Swal.fire(stuResult.message)
                    if (stuResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch student list", error);
            })
    }

    function showList(asesment) {
        const scdlId = asesment.assessmentScheduleId;
        const dt = formatDate(asesment.assessmentDate);
        setScheduleId(scdlId);
        setAssessmentDate(dt)
        const studList = api.AssessmentStudentList + '/' + batchId + '/' + scdlId + '/' + instituteId;
        fetch(studList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studResponse) => studResponse.json())
            .then((studResult) => {
                if (studResult.error == false) {
                    setStudentList(studResult.data)
                    setShowStudentListModal(true)
                }
                else {
                    if (studResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(studResult.message)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch student list for assessment batch', error);
            })
    }

    function showDetails(stud) {
        const bchId = stud.batchBtcId;
        const stdntId = stud.StudentId;
        const studName = stud.StudentName;
        setStudentName(studName);
        const studAssessment = api.AssessmentChartList + '/' + bchId + '/' + scheduleId + '/' + stdntId + '/' + instituteId;
        // "?batchId=" + bchId + "&studentId=" + stdntId + "&insId=" + instituteId + "&scheduleId=" + scheduleId;
        fetch(studAssessment, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((assesmntResponse) => assesmntResponse.json())
            .then((assesmntResult) => {
                if (assesmntResult.error == false) {
                    setStudentAssessmntList(assesmntResult.data)
                    setShowChartModal(true)
                }
                else {
                    Swal.fire(assesmntResult.message)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the student assessment details", error);
            })
    }

    function showEditDetails(stud) {
        const bchId = stud.batchBtcId;
        const stdntId = stud.StudentId;
        const studAssessmentEdit = api.AssessmentEditChartList + '/' + bchId + '/' + scheduleId + '/' + stdntId + '/' + instituteId;
        fetch(studAssessmentEdit, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((assesmntEditResponse) => assesmntEditResponse.json())
            .then((assesmntEditResult) => {
                if (assesmntEditResult.error == false) {
                    // console.log(assesmntEditResult.data);
                    gradList();
                    setStudentAssessmntListEdit(assesmntEditResult.data)
                    setShowChartEditModal(true)
                }
                else {
                    Swal.fire(assesmntEditResult.message)
                }
            })
    }

    function gradList() {
        const getGrade = api.GradeList;
        fetch(getGrade, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((gradeResponse) => gradeResponse.json())
            .then((gradeResult) => {
                if (gradeResult.error == false) {
                    setGradeList(gradeResult.data)
                }
                else {
                    Swal.fire(gradeResult.message)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch grade list", error)
            })
    }

    function getSkillList() {
        const skilList = api.AssesmentStudentsList + '/' + asmntBatchId + '/' + asmntTypeId + '/' + asmntInstituteId;
        // "?batchId=" + asmntBatchId + "&typeId=" + asmntTypeId + "&insId=" + asmntInstituteId;
        fetch(skilList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == false) {
                    setAssessmentSkillList(lstResult.data)
                    setShowSkillTable(true)
                }
                else {
                    Swal.fire(lstResult.message)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch skill list", error)
            })
    }

    function saveAssessment() {
        const assessmentDataArray: { assessmentSkillId: any; assessmentGrade: any; assessmentComment: any; assessmentInst: null; assessmentBtch: null; assessmentType: null; assessmentStudent: null; assessmentScdlDate: any; }[] = [];
        setIsLoading(true)
        setTimeout(() => {
            assessmentSkillList.forEach((skl, index) => {

                let currentGrade = grade[index];
                if (currentGrade === undefined || currentGrade === '') {
                    currentGrade = '6'; // Set default grade to 6
                }

                assessmentDataArray.push({
                    assessmentSkillId: skl.skillId,
                    assessmentGrade: currentGrade,
                    assessmentComment: comment[index],
                    assessmentInst: asmntInstituteId,
                    assessmentBtch: asmntBatchId,
                    assessmentType: asmntTypeId,
                    assessmentStudent: asmntStudId,
                    assessmentScdlDate: assessmentScdlDate
                })

                const formData = new FormData();
                assessmentDataArray.forEach(data => {
                    formData.append('assessmentSkillId', data.assessmentSkillId);
                    formData.append('assessmentGrade', data.assessmentGrade);
                    formData.append('assessmentComments', data.assessmentComment);
                    formData.append('assessmentInstitution', data.assessmentInst);
                    formData.append('assessmentBatch', data.assessmentBtch);
                    formData.append('assessmentType', data.assessmentType);
                    formData.append('assessmentStudent', data.assessmentStudent);
                    formData.append('assessmentSchDate', data.assessmentScdlDate);
                })

                const saveAssmnt = api.CreateAssessment;
                fetch(saveAssmnt, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((saveAssesmntResponse) => saveAssesmntResponse.json())
                    .then((saveAssesmntResult) => {
                        if (saveAssesmntResult.error == false) {
                            setIsLoading(false);
                            Swal.fire(saveAssesmntResult.message)
                            setAsmntStudId('')
                            setShowSkillTable(false)
                            // Reset grades & comments based on new student's skill list length
                            setGrade(Array(assessmentSkillList.length).fill(""));
                            setComment(Array(assessmentSkillList.length).fill(""));
                        }
                        else {
                            setIsLoading(false);
                            Swal.fire(saveAssesmntResult.message)
                        }
                        // handleCloseMarkAssessmnet
                    })
                    .catch((error) => {
                        console.log("Failed to create assessment", error)
                    })
                assessmentDataArray.length = 0;
            })
        }, 1000)
    }

    function updateAssessment() {
        const assessDataArray: { assessmentId: any; assessmentInstitution: string; assessmentGrade: string; assessmentBtch: string; assessmentSchedule: string; }[] = [];
        setIsLoading(true)
        setTimeout(() => {
            studentAssessmntListEdit.forEach((stud, index) => {

                let currentGrade = grade[index] ?? stud.assessmentGradeId;
                if (currentGrade === undefined || currentGrade === '') {
                    currentGrade = '6'; // Set default grade to 6
                }

                assessDataArray.push({
                    assessmentId: stud.assessmentId,
                    assessmentInstitution: instituteId,
                    assessmentGrade: currentGrade,
                    assessmentBtch: stud.assessmentBatchId,
                    assessmentSchedule: stud.assessmentScheduleId,
                })

                const formData = new FormData();
                assessDataArray.forEach(data => {
                    formData.append('assessmentId', data.assessmentId);
                    formData.append('assessmentInstitution', data.assessmentInstitution);
                    formData.append('assessmentGrade', data.assessmentGrade);
                    formData.append('assessmentBatch', data.assessmentBtch);
                    formData.append('assessmentSchedule', data.assessmentSchedule);
                })

                const updateAssmnt = api.UpdateAssessment;
                fetch(updateAssmnt, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((updateAssesmntResponse) => updateAssesmntResponse.json())
                    .then((updateAssesmntResult) => {
                        if (updateAssesmntResult.error == false) {
                            setIsLoading(false);
                            Swal.fire(updateAssesmntResult.message)
                        }
                        else {
                            setIsLoading(false);
                            Swal.fire(updateAssesmntResult.message)
                        }
                        setShowChartEditModal(false)
                    })

                assessDataArray.length = 0;

            })
        }, 1000)

    }

    const filteredData = assessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData, column) => {
        return <span>{rowData.assessmentType}</span>
    }

    const batchRender = (rowData, column) => {
        return <span>{rowData.batchName}</span>
    }

    const levelRender = (rowData, column) => {
        return <span>{rowData.programName}</span>
    }

    const dateRender = (rowData, column) => {
        return <span>{formatDate(rowData.assessmentDate)}</span>
    }

    const selectRow = (rowData) => {
        return (
            <button type="button" className="btn btn-secondary" onClick={() => { showList(rowData) }}>Select</button>
        );
    };

    const detailsRender = (rowData) => {
        return (
            <Link to="#" onClick={() => { showDetails(rowData); }}>
                <i className="feather feather-eye"></i>View Details
            </Link>
        );
    };

    const editRender = (rowData) => {
        return (
            <Link to="#" onClick={() => { showEditDetails(rowData); }}>
                <i className="fas fa-edit"></i>Edit
            </Link>
        );
    };

    const handleCloseStudentList = () => {
        setShowStudentListModal(false);
    };

    const handleCloseChart = () => {
        setShowChartModal(false);
    };

    const handleCloseMarkAssessmnet = () => {
        setShowAddAssessmentModal(false);
    };

    const handleGradeChange = (e, indx) => {
        const updatedGrades = { ...grade, [indx]: e.target.value };
        setGrade(updatedGrades);
    };

    const handleCommentChange = (e, indx) => {
        const updatedComment = { ...comment, [indx]: e.target.value };
        setComment(updatedComment);
    };

    const skillNames = studentAssessmntList && studentAssessmntList.length > 0
        ? studentAssessmntList.map(item => item.skillName)
        : [];

    const gradeTypeValues = studentAssessmntList.map(item => parseInt(item.gradeTypeValue, 10));

    const optionsBar = {
        chart: {
            type: "bar",
            height: 350,
            stacked: false,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                columnWidth: "40%",
                colors: {
                    ranges: [
                        {
                            from: 0,
                            to: 100,
                            color: "#1eb0d5",
                        },
                    ],
                },
                horizontal: false,
                barHeight: "80%",
            },
        },
        stroke: {
            show: true,
            width: 0,
            colors: ["transparent"],
        },
        series: [
            {
                name: "Grade Type Value",
                color: "#1eb0d5",
                data: gradeTypeValues,
            },
        ],
        xaxis: {
            title: {
                text: "Skills", // Label for x-axis
                style: {
                    color: '#777',
                }
            },
            categories: skillNames,
            labels: {
                style: {
                    colors: '#777',
                },
                rotate: -30
            }
        },
        yaxis: {
            title: {
                text: "Grades", // Label for y-axis
                style: {
                    color: '#777',
                }
            },
            labels: {
                style: {
                    colors: "#777",
                },
            },
            tickAmount: 5,
            min: 0,
            max: 5,
        },
        title: {
            text: "",
            align: "left",
            style: {
                fontSize: "18px",
            },
        },
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h4 className="text-center mb-40">Assessment</h4>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12">
                                                            <div className="row col-md-12">
                                                                {(roleId == '1' || roleId == '6') && (
                                                                    <div className="col-md-4">
                                                                        <Link
                                                                            to="#"
                                                                            className="btn btn-secondary"
                                                                            // data-bs-toggle="modal"
                                                                            // data-bs-target="#add-assessment"
                                                                            onClick={initialValues}>
                                                                            <i className="feather-plus" />&nbsp;
                                                                            Add Assessment
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-md-12"></div>
                                                            <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                            <div className="row col-md-12 court-sortby sortbyset">
                                                                <div className="col-md-3">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select
                                                                            value={institutionList.find(ins => ins.institutionId === instituteId) ? {
                                                                                value: instituteId,
                                                                                label: institutionList.find(ins => ins.institutionId === instituteId).institutionName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setInstituteId(e.value);
                                                                                listBatch(e.value)
                                                                            }}
                                                                            options={institutionList.map(ins => ({
                                                                                value: ins.institutionId,
                                                                                label: ins.institutionName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Batch</h6></label>
                                                                        <Select value={batchList.find(bch => bch.batchId === batchId) ? {
                                                                            value: batchId,
                                                                            label: batchList.find(bch => bch.batchId === batchId).batchName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setBatchId(e.value)
                                                                                asesmentList(e.value)
                                                                            }}
                                                                            options={batchList.map(bch => ({
                                                                                value: bch.batchId,
                                                                                label: bch.batchName
                                                                            }))}
                                                                            placeholder={bchPlaceHolder}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {showTable && (
                                                            <>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-6">
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {showTable && (
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                    pageLinkSize={3}
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="slNo"
                                                                        body={slNoRender}
                                                                        header="Sl No"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="assessmentType"
                                                                        body={nameRender}
                                                                        header="Assessment Name"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="batchName"
                                                                        body={batchRender}
                                                                        header="Batch"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="programName"
                                                                        body={levelRender}
                                                                        header="Level"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="assessmentDate"
                                                                        body={dateRender}
                                                                        header="Schedule Date"
                                                                    ></Column>
                                                                    <Column
                                                                        body={selectRow}
                                                                    ></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Assessment Student List */}
            {showStudentListModal && (
                <Modal
                    show={showStudentListModal}
                    size="xl"
                    centered
                    backdrop="static"
                    keyboard={false}
                    scrollable
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0">Student Assessment</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={handleCloseStudentList}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table datatable">
                            <thead className="thead-light">
                                <tr>
                                    <th className="text-uppercase">Student ID</th>
                                    <th className="text-uppercase">Student Name</th>
                                    <th className="text-uppercase">Action</th>
                                    <th></th>
                                </tr>
                                {Array.isArray(studentList) && studentList.map((stud, index) => (
                                    <tr key={index}>
                                        <td>{stud.StudentId}</td>
                                        <td>{stud.StudentName}</td>
                                        <td>{detailsRender(stud)}</td>
                                        {(roleId == 1 || roleId == 3 || roleId == 6) ? (
                                            <>
                                                <td>{editRender(stud)}</td>
                                            </>
                                        ) : null}
                                    </tr>
                                ))}
                            </thead>
                        </table>
                    </ModalBody>
                </Modal>
            )}
            {/* /Assessment Student list */}

            {/* Student Assessment Chart List */}
            {showChartModal && (
                <Modal
                    show={showChartModal}
                    size="xl"
                    centered
                    scrollable
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0">Assessment of {studentName} on {assessmentDate}</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={handleCloseChart}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div id="bar">
                                <ReactApexChart
                                    options={optionsBar}
                                    series={optionsBar.series}
                                    type="bar"
                                    height={400}
                                    width="100%"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="table-responsive table-datatble">
                                <table className="table datatable">
                                    <thead className="thead-light">
                                        <tr>
                                            <th className="text-uppercase">Skill</th>
                                            <th className="text-uppercase">Grade Obtained (A is max)</th>
                                        </tr>
                                        {Array.isArray(studentAssessmntList) && studentAssessmntList.map((asmnt, index) => (
                                            <tr key={index}>
                                                <td>{asmnt.skillName}</td>
                                                <td>{asmnt.gradeType}</td>
                                            </tr>
                                        ))}
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            )}
            {/* /Student Assessment Chart List */}

            {/* Add assessment */}

            {showAddAssessmentModal && (
                <Modal
                    show={showAddAssessmentModal}
                    size="xl"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">Mark Assessment</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={handleCloseMarkAssessmnet}
                        ></Button>
                    </ModalHeader>

                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12"></div>
                            <div className="row col-md-12 court-sortby sortbyset">
                                <div className="col-md-4">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                        <Select
                                            value={institutionList.find(ins => ins.institutionId === asmntInstituteId) ? {
                                                value: instituteId,
                                                label: institutionList.find(ins => ins.institutionId === asmntInstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setAsmntInstituteId(e.value);
                                                listBatch(e.value)
                                            }}
                                            options={institutionList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Batch</h6></label>
                                        <Select value={batchList.find(bch => bch.batchId === asmntBatchId) ? {
                                            value: batchId,
                                            label: batchList.find(bch => bch.batchId === asmntBatchId).batchName
                                        } : null}
                                            onChange={(e) => {
                                                setAsmntBatchId(e.value)
                                                asesmentDateList(e.value)
                                            }}
                                            options={batchList.map(bch => ({
                                                value: bch.batchId,
                                                label: bch.batchName
                                            }))}
                                            placeholder={asmntDatePlaceHolder}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Type</h6></label>
                                        <Select value={assessmentTypeList.find(typ => typ.assessmentTypeId === asmntTypeId) ? {
                                            value: asmntTypeId,
                                            label: assessmentTypeList.find(bch => bch.assessmentTypeId === asmntTypeId).assessmentType
                                        } : null}
                                            onChange={(e) => {
                                                setAsmntTypeId(e.value)
                                            }}
                                            options={assessmentTypeList.map(typ => ({
                                                value: typ.assessmentTypeId,
                                                label: typ.assessmentType
                                            }))}
                                            placeholder="Select an Assessment Type"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Assessment Date</h6></label>
                                        <Select value={assessmentDateList.find(date => date.scheduleId === assessmentScdlDate) ? {
                                            value: scheduleId,
                                            label: formatDate(assessmentDateList.find(date => date.scheduleId === assessmentScdlDate).scheduleDate)
                                        } : null}
                                            onChange={(e) => {
                                                setAssessmentScdlDate(e.value)
                                                getStudents(e.value)
                                            }}
                                            options={assessmentDateList.map(date => ({
                                                value: date.scheduleId,
                                                label: formatDate(date.scheduleDate)
                                            }))}
                                            placeholder={asmntDatePlaceHolder}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Student</h6></label>
                                        <Select value={asmntStudList.find(stud => stud.coreUserId === asmntStudId) ? {
                                            value: asmntStudId,
                                            label: asmntStudList.find(stud => stud.coreUserId === asmntStudId).StudentName
                                        } : null}
                                            onChange={(e) => {
                                                setAsmntStudId(e.value)
                                                getSkillList()
                                                gradList()
                                            }}
                                            options={asmntStudList.map(stud => ({
                                                value: stud.coreUserId,
                                                label: stud.StudentName
                                            }))}
                                            placeholder={studPlaceHolder}
                                        />
                                    </div>
                                </div>
                            </div>
                            {showSkillTable && (
                                <>
                                    <div className="table-responsive table-datatble">
                                        <table className="table datatable">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th className="text-uppercase">Skill</th>
                                                    <th className="text-uppercase">Grade</th>
                                                    <th className="text-uppercase">Comment</th>
                                                </tr>
                                                {Array.isArray(assessmentSkillList) && assessmentSkillList.map((skil, index) => (
                                                    <tr key={index}>
                                                        <td>{skil.skillName}</td>
                                                        <td>
                                                            <select value={grade[index]} onChange={(e) => handleGradeChange(e, index)}>
                                                                <option value="" selected disabled>Select grade</option>
                                                                {Array.isArray(gradeList) && gradeList.map((grd) => (
                                                                    <option key={grd.gradeTypeId} value={grd.gradeTypeId}>{grd.gradeType}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input type="text" value={comment[index]} onChange={(e) => handleCommentChange(e, index)} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </thead>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={() => { saveAssessment(); }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b>Accept</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            )}

            {showChartEditModal && (
                <Modal
                    show={showChartEditModal}
                    size="xl"
                    centered
                    onHide={() => setShowChartEditModal(false)}
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0"><i className="fas fa-truck" />Modify Assessment</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setShowChartEditModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <table className="table datatable">
                            <thead className="thead-light">
                                <tr>
                                    <th className="text-uppercase">Skill</th>
                                    <th className="text-uppercase">Grade Obtained(A is MAX)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(studentAssessmntListEdit) && studentAssessmntListEdit.map((stud, index) => (
                                    <tr key={index}>
                                        <td>{stud.skillName}</td>
                                        <td>
                                            <select
                                                value={grade[index] ?? stud.assessmentGradeId ?? ""}
                                                onChange={(e) => handleGradeChange(e, index)}
                                            >
                                                <option value="" disabled>Select grade</option>
                                                {Array.isArray(gradeList) &&
                                                    gradeList.map((grd) => (
                                                        <option key={grd.gradeTypeId} value={grd.gradeTypeId}>
                                                            {grd.gradeType}
                                                        </option>
                                                    ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={updateAssessment}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b>Accept</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            {/* <div
                className="modal custom-modal fade request-modal"
                id="add-assessment"
                role="dialog"

            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Mark Assessment
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12"></div>
                                <div className="row col-md-12 court-sortby sortbyset">
                                    <div className="col-md-4">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                            <Select
                                                value={institutionList.find(ins => ins.institutionId === asmntInstituteId) ? {
                                                    value: instituteId,
                                                    label: institutionList.find(ins => ins.institutionId === asmntInstituteId).institutionName
                                                } : null}
                                                onChange={(e) => {
                                                    setAsmntInstituteId(e.value);
                                                    listBatch(e.value)
                                                }}
                                                options={institutionList.map(ins => ({
                                                    value: ins.institutionId,
                                                    label: ins.institutionName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                            <Select value={batchList.find(bch => bch.batchId === asmntBatchId) ? {
                                                value: batchId,
                                                label: batchList.find(bch => bch.batchId === asmntBatchId).batchName
                                            } : null}
                                                onChange={(e) => {
                                                    setAsmntBatchId(e.value)
                                                    asesmentDateList(e.value)
                                                }}
                                                options={batchList.map(bch => ({
                                                    value: bch.batchId,
                                                    label: bch.batchName
                                                }))}
                                                placeholder={asmntDatePlaceHolder}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Type</h6></label>
                                            <Select value={assessmentTypeList.find(typ => typ.assessmentTypeId === asmntTypeId) ? {
                                                value: asmntTypeId,
                                                label: assessmentTypeList.find(bch => bch.assessmentTypeId === asmntTypeId).assessmentType
                                            } : null}
                                                onChange={(e) => {
                                                    setAsmntTypeId(e.value)
                                                }}
                                                options={assessmentTypeList.map(typ => ({
                                                    value: typ.assessmentTypeId,
                                                    label: typ.assessmentType
                                                }))}
                                                placeholder="Select an Assessment Type"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Assessment Date</h6></label>
                                            <Select value={assessmentDateList.find(date => date.scheduleId === assessmentScdlDate) ? {
                                                value: scheduleId,
                                                label: formatDate(assessmentDateList.find(date => date.scheduleId === assessmentScdlDate).scheduleDate)
                                            } : null}
                                                onChange={(e) => {
                                                    setAssessmentScdlDate(e.value)
                                                    getStudents(e.value)
                                                }}
                                                options={assessmentDateList.map(date => ({
                                                    value: date.scheduleId,
                                                    label: formatDate(date.scheduleDate)
                                                }))}
                                                placeholder={asmntDatePlaceHolder}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Student</h6></label>
                                            <Select value={asmntStudList.find(stud => stud.coreUserId === asmntStudId) ? {
                                                value: asmntStudId,
                                                label: asmntStudList.find(stud => stud.coreUserId === asmntStudId).StudentName
                                            } : null}
                                                onChange={(e) => {
                                                    setAsmntStudId(e.value)
                                                    getSkillList()
                                                    gradList()
                                                }}
                                                options={asmntStudList.map(stud => ({
                                                    value: stud.coreUserId,
                                                    label: stud.StudentName
                                                }))}
                                                placeholder={studPlaceHolder}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {showSkillTable && (
                                    <>
                                        <div className="table-responsive table-datatble">
                                            <table className="table datatable">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th className="text-uppercase">Skill</th>
                                                        <th className="text-uppercase">Grade</th>
                                                        <th className="text-uppercase">Comment</th>
                                                    </tr>
                                                    {Array.isArray(assessmentSkillList) && assessmentSkillList.map((skil, index) => (
                                                        <tr key={index}>
                                                            <td>{skil.skillName}</td>
                                                            <td>
                                                                <select value={grade[index]} onChange={(e) => handleGradeChange(e, index)}>
                                                                    <option value="" selected disabled>Select grade</option>
                                                                    {Array.isArray(gradeList) && gradeList.map((grd) => (
                                                                        <option key={grd.gradeTypeId} value={grd.gradeTypeId}>{grd.gradeType}</option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input type="text" value={comment[index]} onChange={(e) => handleCommentChange(e, index)} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </thead>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={saveAssessment}>
                                    Save
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* /Add assessment */}
        </>
    );
};

export default Assessment;